module.exports = __webpack_public_path__ + "media/images/screenshots/home-08277ea3dcaa9c2e4a29ddb0af8129d9.png";